import { getRequest } from "api/apiCaller";
import Autocomplete from "components/Autocomplete";
import { isNil } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";

const OPTIONS_SIZE = 15;

const AutocompleteSubOrg = ({ query, where, ...otherProps }) => {
  const [subOrgs, setSubOrgs] = useState([]);
  const subOrgSearchKey = useRef("");

  const getSubOrgs = useCallback(
    async (fullname, limit) => {
      const whereFilter = {
        ...(fullname && { fullname: { like: fullname, options: "i" } }),
        ...(where?.citycode &&
          !where?.districtcode && { citycode: where.citycode }),
        ...(where?.districtcode && {
          districtcode: where.districtcode,
        }),
        ...(!isNil(where?.isCskh) && { isCskh: where.isCskh }),
      };
      const { data } = await getRequest("/vnpost/province", {
        ...(query && { query }),
        filter: { where: whereFilter, limit },
      });
      setSubOrgs(data);
    },
    [query, where]
  );

  useEffect(() => {
    getSubOrgs("", OPTIONS_SIZE);
  }, [getSubOrgs]);

  return (
    <div>
      <Autocomplete
        options={subOrgs}
        onTextChange={(text) => {
          subOrgSearchKey.current = text;
          getSubOrgs(text, OPTIONS_SIZE);
        }}
        getLabel={(option) => option?.name || ""}
        onScrollBottom={(text, currentLength) => {
          getSubOrgs(subOrgSearchKey.current, currentLength + OPTIONS_SIZE);
        }}
        onClose={() => {
          subOrgSearchKey.current = "";
          getSubOrgs("", OPTIONS_SIZE);
        }}
        label="Bưu cục"
        debounceTime={300}
        InputLabelProps={{
          shrink: true,
        }}
        isVisibleAllOption
        {...otherProps}
      />
    </div>
  );
};

export default AutocompleteSubOrg;
